import { useEffect, useRef, useState } from "react";
import { NotificationClickEvent } from "onesignal-cordova-plugin";

import useBoundStore from "store";
import { oneSignalInit, oneSignalLogin } from "services/OneSignal";
import { viteMode } from "utils/env";

export default function RegisterPushNotifications() {
  const [canLogin, setCanLogin] = useState(false);
  const authUserId = useBoundStore((state) => state.user.auth?.id);
  const setNotification = useBoundStore((state) => state.notification.set);
  const initialized = useRef(false);

  function handleNotification(e: NotificationClickEvent) {
    // TODO handle notification click for mobile
  }

  useEffect(() => {
    if (!initialized.current && viteMode !== "staging") {
      initialized.current = true;
      oneSignalInit(handleNotification).then(async () => {
        setCanLogin(true);
      });
    }
  }, [authUserId, setNotification]);

  useEffect(() => {
    if (authUserId && canLogin) {
      oneSignalLogin(authUserId.toString());
    }
  }, [authUserId, canLogin]);

  return null;
}
